import { motion } from 'framer-motion';
import Container from './Container';
import SectionHeading from './SectionHeading';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';
import { workAreas } from '@/lib/content';

export default function SelectWork() {
  return (
    <section id="work" aria-labelledby="work-heading" className="py-24 md:py-36">
      <Container>
        <SectionHeading
          eyebrow="Where we create leverage"
          title={
            <span id="work-heading">
              Select engagements, <span className="text-ink/50">across</span> industries that
              take technology seriously.
            </span>
          }
          lede="We work with a small number of operators each year. The list below describes the kinds of organizations where our judgment and execution tend to create the most leverage."
        />

        <motion.dl
          variants={stagger(0.05, 0.06)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-16 grid grid-cols-1 gap-x-12 gap-y-10 md:grid-cols-2 md:gap-y-14"
        >
          {workAreas.map((area, idx) => (
            <motion.div
              key={area.label}
              variants={fadeUp}
              className="group relative border-t border-ink/10 pt-6"
            >
              <div className="flex items-baseline justify-between">
                <dt className="font-display text-xl tracking-tight md:text-[1.5rem]">
                  {area.label}
                </dt>
                <span className="font-mono text-xs text-ink/40">
                  {String(idx + 1).padStart(2, '0')}
                </span>
              </div>
              <dd className="mt-3 max-w-md text-[15px] leading-relaxed text-ink/70">
                {area.body}
              </dd>
              <span
                aria-hidden
                className="absolute left-0 top-0 h-px w-0 bg-ink transition-all duration-700 group-hover:w-full"
              />
            </motion.div>
          ))}
        </motion.dl>
      </Container>
    </section>
  );
}
